import { render, staticRenderFns } from "./DreamListOptionsModal.vue?vue&type=template&id=7b5e827d&"
import script from "./DreamListOptionsModal.vue?vue&type=script&lang=ts&"
export * from "./DreamListOptionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./DreamListOptionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports